import ac from 'argument-contracts';

export class Repository {
    constructor({get, set}) {
        ac.assertFunction(get, 'options.get');
        if(set) {
            ac.assertFunction(set, 'options.set');
        }

        this.get = get;
        this.set = set;

        Object.freeze(this);
    }
}